import { render, staticRenderFns } from "./DialogAyuda.vue?vue&type=template&id=4bd0a69e&scoped=true"
import script from "./DialogAyuda.vue?vue&type=script&lang=js"
export * from "./DialogAyuda.vue?vue&type=script&lang=js"
import style0 from "./DialogAyuda.vue?vue&type=style&index=0&id=4bd0a69e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd0a69e",
  null
  
)

export default component.exports